import type { ReactNode } from 'react'

import { Typography } from '@/UI-KIT/Typography/Typography'

import styles from './FeatureCard.module.scss'

type FeatureCardProps = {
  plate: ReactNode
  title: string
  text: string
}

/**
 * Padding lives on the body, not the card, so the plate is full-bleed; `overflow: hidden` is what
 * clips the plate's top corners to the 20px radius.
 *
 * There is no big step numeral here any more, and that is the fix rather than a trim. It was a
 * second watermark: every plate already draws its own sequence mark (`PlateRegister`, the pale
 * "01/02/03" on the rule), so the card said the number twice. The big one was absolutely positioned
 * over a static plate, which is why it painted ON TOP of the drawing — measured at 303-335 x 17-73
 * it sat on card 02's score chip and card 03's message bubble. It could not be moved behind either:
 * the plate band is opaque (`var(--strip)`), so a numeral under it is simply gone, and none of the
 * three drawings has a free corner to move it to.
 */
export const FeatureCard = ({ plate, title, text }: FeatureCardProps) => (
  <article className={styles.root}>
    {plate}
    <div className={styles.body}>
      <Typography variant="h3" color="heading" component="h3" className={styles.title}>
        {title}
      </Typography>
      <Typography variant="t3" color="ink2">
        {text}
      </Typography>
    </div>
  </article>
)
